import React from 'react';

import { Container } from './styles';

function BlackContainer({ children }) {
  return (
    <Container>
      {children}
    </Container>
  );
}

export default BlackContainer;
